<script setup lang="ts">
import type { EventVaultSettings, Media } from "@/models"
import { computed } from "vue"
import { FeedTile } from "@/components"
import { SocialsBehavior } from "@/types"

interface GalleryFeedProps {
  media: Media[]
  eventSettings?: EventVaultSettings
}

const { eventSettings = undefined } = defineProps<GalleryFeedProps>()

const emit = defineEmits<{
  (e: "view", index: number): void
  (e: "viewComments", mediaItem: Media): void
}>()

const areReactionsEnabled = computed(() => {
  const socialsBehavior = eventSettings?.socialsBehavior
  return socialsBehavior === SocialsBehavior.ReactionsOnly || socialsBehavior === SocialsBehavior.ReactionsAndComments
})

const areCommentsEnabled = computed(() => {
  const socialsBehavior = eventSettings?.socialsBehavior
  return socialsBehavior === SocialsBehavior.CommentsOnly || socialsBehavior === SocialsBehavior.ReactionsAndComments
})

const onView = (index: number) => emit("view", index)

const onViewComments = (mediaItem: Media) => emit("viewComments", mediaItem)
</script>

<template>
  <div class="w-full flex flex-col items-center">
    <div v-for="(mediaItem, index) in media" :key="mediaItem.id" class="w-full md:max-w-[480px]">
      <FeedTile
        :media="mediaItem"
        :are-reactions-enabled="areReactionsEnabled"
        :are-comments-enabled="areCommentsEnabled"
        :is-scrolling="false"
        @view-comments="onViewComments"
        @click="() => onView(index)"
      />
    </div>
  </div>
</template>
